import { IconFilter16 } from '@warp-ds/icons/react/filter-16';
import { IconMap16 } from '@warp-ds/icons/react/map-16';
import { Button } from '@warp-ds/react/components/button';
import { useRouter } from 'next/router';
import { Sorting } from 'shared/page/result/Sorting';
import type { AutocompleteData, Filters } from '@/domain';
import type { LoginId } from '@/types/common';
import { parseUrl } from '../utils/parseUrl';
import { SaveSearch } from './saveSearch/SaveSearch';

const SORTING_OPTIONS = [
    { value: 'best', label: 'Mest relevant' },
    { value: 'published', label: 'Publisert' },
    { value: 'price_asc', label: 'Pris lav-høy' },
    { value: 'price_desc', label: 'Pris høy-lav' },
    { value: 'bedroom_asc', label: 'Soverom lav-høy' },
    { value: 'bedroom_desc', label: 'Soverom høy-lav' },
];

type ResultsToolbarProps = {
    showFilters: boolean;
    toggleFilters: () => void;
    filters: Filters;
    autocompleteData?: AutocompleteData;
    loginId?: LoginId;
    onFilterChanged: (filter: Filters) => void;
};

export const ResultsToolbar = ({
    showFilters,
    toggleFilters,
    filters,
    autocompleteData,
    loginId,
    onFilterChanged,
}: ResultsToolbarProps) => {
    const router = useRouter();
    const searchParams = parseUrl(router.query);

    return (
        <div className="flex items-center w-full md:justify-between gap-8 md:gap-16 my-16 md:mt-0" data-testid="topBar">
            <div className="flex items-center gap-8 sm:gap-16">
                <Button
                    primary={showFilters}
                    utility={!showFilters}
                    small
                    onClick={toggleFilters}
                    aria-label={showFilters ? 'Vis resultat' : 'Vis filter'}
                    className="flex items-center gap-8 md:hidden whitespace-nowrap"
                    data-testid="showFilterButton">
                    <IconFilter16 aria-hidden />
                    Filter
                </Button>
                <Button
                    utility
                    small
                    href={`${router.basePath}/kart/?${searchParams.toString()}`}
                    className="flex items-center gap-8 md:hidden whitespace-nowrap"
                    data-testid="openMapButton">
                    <IconMap16 aria-hidden />
                    <span className="sr-only">Vis i kart</span>
                </Button>
                <SaveSearch filters={filters} autocompleteData={autocompleteData} isLoggedIn={!!loginId} data-testid="save-search-box" />
            </div>
            <Sorting
                sortOptions={SORTING_OPTIONS}
                defaultSort="best"
                selectedSort={filters.sorting ?? undefined}
                onChange={(value) => onFilterChanged({ sorting: value })}
            />
        </div>
    );
};
